import React, { useEffect, useState } from 'react';
import ThemeCustomization from 'themes';
import { useDispatch, useSelector } from 'react-redux';
import Routes from 'routes';
import { useLocation, useNavigate } from 'react-router';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

import { ContextProvider as AuthContextProvider } from './auth/auth-context';
import './styles/geofence.css'
import { showAppAlert } from 'store/reducers/appreducer';

import { routerHistory } from 'utils/helpers';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function App() {
  
  routerHistory.navigate = useNavigate();
  routerHistory.location = useLocation();
  const dispatch = useDispatch();

  const { appAlert } = useSelector((state) => state.appreducer);
  const [alert, setAlert] = useState(appAlert);


  const handleAlertClose = () => {
    const alert = {
      show: false,
      alertType: '',
      alertMessage: ''
    };
    setAlert(alert);
    dispatch(showAppAlert(alert));
  };

  useEffect(() => {
    setAlert(appAlert);
  }, [appAlert]);

  return (
    <ThemeCustomization>
      <AuthContextProvider>
        <Routes />
      </AuthContextProvider>
      <Snackbar open={alert.show} autoHideDuration={6000} onClose={handleAlertClose}>
        <Alert onClose={handleAlertClose} severity={alert.alertType} sx={{ width: '100%' }}>
          {alert.alertMessage}
        </Alert>
      </Snackbar>
    </ThemeCustomization>
  );
}
